
import { message } from 'antd';
import { unionBy, find } from 'lodash';
import { guid } from '../utils/';
import { addAndUpdateVendorSmtSection, getVendorSmtSection, addVendorAssemblySection, getVendorAssemblySection } from '../services/supplierApi';

function init() {
  return {
    data: [{
      monthlyUsageText: '>100K',
      monthlyUsageM: 'moreThanHk',
      tempId: guid(),
    }, {
      monthlyUsageText: '50K~100K(含)',
      monthlyUsageM: 'moreThanFk',
      tempId: guid(),
    }, {
      monthlyUsageText: '10K~50K(含)',
      monthlyUsageM: 'moreThanOk',
      tempId: guid(),
    }, {
      monthlyUsageText: '≤10K',
      monthlyUsageM: 'lessThanOk',
      tempId: guid(),
    }],
    record: {},
  };
}

export default {
  namespace: 'section',
  state: init(),
  effects: {
    *getVendorSmtSection(_, { call, put, select }) {
      const res = yield call(getVendorSmtSection);
      let data = yield select(state => state.section.data);
      data = data.map((item) => {
        const record = find(res.data, { 'monthlyUsageM': item.monthlyUsageM });
        return { ...item, ...record };
      });
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: unionBy(data, res.data, 'monthlyUsageM')
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *getVendorAssemblySection(_, { call, put }) {
      const res = yield call(getVendorAssemblySection);
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              record: res.data || {}
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *submitData({ payload }, { call }) {
      const { data: { smtSection, assemblySection } } = payload;
      const res1 = yield call(addVendorAssemblySection, assemblySection);
      const res2 = yield call(addAndUpdateVendorSmtSection, smtSection);
      if (res1.success && res2.success) {
        message.success('操作成功');
      } else {
        !res1.success && res1.msg && message.error(res1.msg);
        !res2.success && res2.msg && message.error(res2.msg);
      }
      return res1.success && res2.success;
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};

